import { red, yellow } from '@mui/material/colors'
import React, { useCallback, useEffect, useState, useRef, useContext } from 'react'
import brokerApi from '../../../api/brokerApi';
import helper from '../../../helper';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { RHFAutocomplete } from '../../../Components/RHFAutocomplete';
import { Box, Button, CircularProgress, Container, Grid, IconButton, Modal, Tooltip, Typography } from '@mui/material';
import RtlProvider from '../../../Components/RtlProvider';
import reservationApi from '../../../api/reservationApi';
import { useReactToPrint } from 'react-to-print';
import { MdClose, MdPrint } from "react-icons/md";
import Loading from '../../../Components/Loading';
import { ContextUserInfo } from '../MainPanel';
import cityApi from '../../../api/cityApi';
import ChunkedPlanRooms from '../../../Components/ChunkedPlanRooms';
import brokerGroupApi from '../../../api/brokerGroupApi';
import staticVariablesApi from '../../../api/staticVariablesApi';
import enumMapper from '../../../enumMapper';
import InitialPlanFooter from '../../../Components/InitialPlanFooter';
import moment from 'jalali-moment';
import PassengerInfo from './PassengerInfo';
import { Watch } from '@mui/icons-material';
import passengerInfoApi from '../../../api/passengerInfoApi';
import { ContextNotification, severitys } from '../../../App';
import BeatLoading from '../../../Components/Loader/BeatLoader';

export const InitialPlan = () => {
  const { userInfo } = useContext(ContextUserInfo);
  const { open, setOpen } = useContext(ContextNotification);
  const [Cities, SetCities] = useState([]);
  const [Brokers, SetBrokers] = useState([]);
  const [GroupNumbers, setGroupNumbers] = useState([]);
  const [FilterResult, setFilterResult] = useState(null);
  const [CurrentDateTime, setCurrentDateTime] = useState('');
  const [loading, setLoading] = useState(false);
  const [passengerInfoLoading, setPassengerInfoLoading] = useState(false)
  const [passengerInfo, setPassengerInfo] = useState(null);

  const schema = yup.object().shape({
    brokerGroupId: yup.string().required("شماره گروه را انتخاب نمایید"),
    brokerId: yup.string().required(" کارگزار را انتخاب نمایید"),
    CityConsistency: yup.string().required(" شهر را انتخاب نمایید"),
  });
  const { register, setValue, handleSubmit, formState: { errors, isSubmitSuccessful }, control, resetField, watch } = useForm({
    resolver: yupResolver(schema),
  });
  const onSubmit = (data) => {
    setLoading(true);
    reservationApi.Filter(parseInt(data?.CityConsistency), data?.brokerGroupId)
      .then(res => {
        setFilterResult(res.data.data);
        staticVariablesApi.GetCurrentDateTime().then(res => {
          moment.locale('fa');
          setCurrentDateTime(moment.from(res.data, 'en', 'YYYY-MM-DD[T]HH:mm:ss[Z]').format('YYYY/MM/DD HH:mm'));
        }).catch(err => console.log(err))

      }).catch(err => {
        console.log(err)
      }).finally(() => setLoading(false));
  };

  useEffect(() => {
    GetBrokerDropDown(userInfo);
    GetCityDropDown();

  }, []);
  const GetBrokerDropDown = (userInfo) => {

    if (userInfo?.brokerNo) {
      brokerApi.GetByBrokerCode(userInfo.brokerNo).then(res => {
        const kargozar = [];
        kargozar.push(res.data.data)
        SetBrokers(kargozar.map((r) => {
          return {
            id: r.id,
            label: r.name + "-" + r.code
          };
        }));
        setValue('brokerId', res.data.data.id)
        GetSelectedBrokerGroupNumbers(res.data.data.id)
      }).catch(err => {
      })
    }
    else {
      brokerApi
        .BrokerDropDown()
        .then((res) => {
          const arr = helper.DictionayToList(res.data.data)
          SetBrokers(arr.map((r) => {
            return {
              id: r.key,
              label: r.value
            };
          }))
        })
        .catch((error) => console.log(error));
    }
  };

  const handleBrokerChanged = useCallback(async (id) => {
    resetField("brokerGroupId");
    setGroupNumbers(null);
    if (id) {
      const groupNumbers = await fetchGroupNumbersByBrokerId(id);
      setGroupNumbers(
        groupNumbers.map((o) => {
          return {
            id: o.key,
            label: o.value
          };
        })
      );
    }
  }, [])
  const handleGroupNumberChanged = (id) => {
  }
  const fetchGroupNumbersByBrokerId = async (brokerId) => {
    try {
      let res = await brokerGroupApi.BrokerGroupDropDown(brokerId)

      if (res.status == 200) {
      }
      const arr = helper.DictionayToList(res.data.data)
      return arr;
    }
    catch (err) {
      console.error(err);
    }
  };
  const GetSelectedBrokerGroupNumbers = (brokerId) => {
    try {
      brokerGroupApi.BrokerGroupDropDown(brokerId).then(res => {
        const groupNumbers = helper.DictionayToList(res.data.data)
        setGroupNumbers(
          groupNumbers.map((o) => {
            return {
              id: o.key,
              label: o.value
            };
          })
        );
      }).catch(err => {
      });

    }
    catch (err) {
      console.error(err);
    }
  };

  const contentToPrint = useRef(null);
  const handlePrint = useReactToPrint({
    documentTitle: "Print This Document",
    onBeforePrint: () => { },
    onAfterPrint: () => { },
    removeAfterPrint: true,
  });


  const GetCityDropDown = () => {
    staticVariablesApi.GetArabicCityConsistencyDropDown()
      .then((res) => {
        const arr = helper.DictionayToList(res.data.data)
        const mappedReponse = arr.map((r) => {
          return {
            id: r.key,
            label: r.value
          };
        });
        SetCities(mappedReponse);
      })
      .catch((error) => console.log(error));
  };
  const handleCityChanged = (id) => { };


  const [openPassengerInfoModal, setOpenPassengerInfoModal] = useState(false);
  const handleOpenPassengerInfoModal = (brokerGroupId) => {
    if (brokerGroupId) {
      setPassengerInfoLoading(true);
      passengerInfoApi.PassengerInfoByBrokerGroupId(brokerGroupId)
        .then(res => {
          if (res.data.success) {
            if (res.data.data) {
              setPassengerInfo(res.data.data)
              setOpenPassengerInfoModal(true);
            }
            else {
              setOpen({ IsEnable: true, Message: 'زائری یافت نشد', severity: severitys.error });
            }

          }
          else {
            setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.error });
          }
        })
        .catch(err => {
          if (err.response && err.response.data && err.response.data.errors) {
            setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
          }
          else if (err.response && err.response.data) {
            setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
          }
          else if (err.message) {
            setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
          }
          else {
            setOpen({ IsEnable: true, Message: JSON.stringify(err), severity: severitys.error });
          }
        }).finally(() => { setPassengerInfoLoading(false); });
    }
  };
  const handleClosePassengerInfoModal = () => {

    setPassengerInfo(null);
    setOpenPassengerInfoModal(false);
  };
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 6,
    overflow: 'scroll',
    height: '100%',
    width: { xs: '90%', md: 'auto' },
  };

  return (
    <Container component="main">
      <form onSubmit={handleSubmit(onSubmit)}>
        <RtlProvider>
          <Typography component="h1" variant="h5" mb={2}>پلان اقامتی کارگزار</Typography>
          <Typography sx={{ color: "red", fontSize: '20px' }}>          قابل توجه کارگزاران ارجمند</Typography>
          <Typography sx={{ color: "red", marginBottom: 4, marginLeft: 1, fontSize: '18px' }}>پلان اقامتی 5 روز پیش از تاریخ پرواز بر روی سامانه قرار می گیرد، ولی با توجه به احتمال ایجاد تغییر در پلان هتلها، لازم است حتما ۴۸ ساعت پیش از پرواز نیز نسبت به دریافت پلان اقامتی نهایی اقدام نموده تا در صورت ایجاد تغییر احتمالی از موضوع مطلع گردید.</Typography>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={3}>
              <RHFAutocomplete
                loading={!Brokers?.length}
                control={control}
                options={Brokers ?? []}
                name="brokerId"
                placeholder="کارگزار"
                onChange={handleBrokerChanged}
                error={!!errors?.brokerId}
                helperText={errors?.brokerId?.message}
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <RHFAutocomplete
                control={control}
                options={Cities ?? []}
                name="CityConsistency"
                placeholder="شهر"
                onChange={handleCityChanged}
                style={{
                  border: "none",
                  padding: 0
                }}
                error={!!errors?.CityConsistency}
                helperText={errors?.CityConsistency?.message}
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <RHFAutocomplete
                control={control}
                options={GroupNumbers ?? []}
                name="brokerGroupId"
                placeholder="گروه"
                onChange={handleGroupNumberChanged}
                error={!!errors?.brokerGroupId}
                helperText={errors?.brokerGroupId?.message}
              />
            </Grid>
            <Grid item xs={12} sm={5}>
              <Button type="submit" variant="contained" color="secondary">جستجو</Button>
              {
                watch("brokerGroupId") && <Button variant="contained" onClick={() => {
                  handleOpenPassengerInfoModal(watch("brokerGroupId"))
                }} sx={{ whiteSpace: 'nowrap', marginLeft: 1 }}>
                  <BeatLoading loading={passengerInfoLoading} color={"#e65100"} size={8} />لیست زائران
                </Button>
              }
            </Grid>
          </Grid>

          {
            loading ? <Loading /> :
              FilterResult ? (
                <>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                    }}
                  >
                    <Tooltip title="چاپ" placement="top">
                      <IconButton style={{ margin: '2px' }} onClick={() => {
                        handlePrint(null, () => contentToPrint.current);
                      }}>
                        <MdPrint color='rgb(22, 95, 129)' />
                      </IconButton>
                    </Tooltip>
                  </Box>
                  <div style={{ overflowX: 'auto' }}>
                    <div ref={contentToPrint}>
                      <div dir='ltr'>{CurrentDateTime}</div>
                      <table width={'100%'} cellSpacing={0} className='initialplantable' dir='rtl'>
                        <tbody>
                          <tr style={{ background: "#f2f2f2" }}>
                            <th colSpan="4">نام کارگزار</th>
                            <th colSpan="3">شماره کارگزار</th>
                            <th colSpan="1">شماره گروه</th>
                            <th colSpan="1">شرکت مجری عربی</th>
                            <th colSpan="1">تاریخ پرواز</th>
                            <th colSpan="1">تاریخ نگارش</th>
                          </tr>
                          <tr style={{ background: "#f2f2f2" }}>
                            <td colSpan="4">{FilterResult?.reserveInfo?.brokerName}</td>
                            <td colSpan="3">{FilterResult?.reserveInfo?.brokerCode} </td>
                            <td colSpan="1"> {FilterResult?.reserveInfo?.groupNumber}</td>
                            <td colSpan="1"> {FilterResult?.reserveInfo?.companyName} </td>
                            <td colSpan="1">{FilterResult?.reserveInfo?.flightDate} </td>
                            <td colSpan="1">{FilterResult?.reserveInfo?.createDate} </td>
                          </tr>
                          <tr style={{ background: "#f8cbae" }}>
                            <th colSpan={2}>نام هتل</th>
                            <th colSpan={2}>شهر</th>
                            <th>کد پلان</th>
                            <th>گروه قیمتی</th>
                            <th>ظرفیت</th>
                            <th>اعزام روز</th>
                            <th>تعداد کل اتاق</th>
                            <th>ایستگاه پروازی</th>
                            <th>هواپیمایی</th>
                          </tr>
                          <tr style={{ background: FilterResult?.planInfo?.colorCode }}>
                            <td colSpan={2}> {FilterResult?.reserveInfo?.hotelName}</td>
                            <td colSpan={2}>{FilterResult?.reserveInfo?.cityName}</td>
                            <td> {FilterResult?.planInfo?.planCode}</td>
                            <td> {FilterResult?.reserveInfo?.priceGroupName}</td>
                            <td>{FilterResult?.reserveInfo?.capacity}</td>
                            <td>{FilterResult?.reserveInfo?.dispatchOfTheDayTitle} </td>
                            <td>{FilterResult?.reserveInfo?.roomCount}  </td>
                            <td>{FilterResult?.reserveInfo?.flightOriginName} </td>
                            <td>{FilterResult?.reserveInfo?.airLineName}</td>
                          </tr>
                          <tr>
                            <th>آدرس</th>
                            <td colSpan={11}>{FilterResult?.reserveInfo?.address}</td>
                          </tr>
                          <tr>
                            <th>آدرس عربی</th>
                            <td colSpan={11}>{FilterResult?.reserveInfo?.arabianAddress}</td>
                          </tr>
                          <tr>
                            <th>تلفن</th>
                            <td colSpan={1} style={{ width: '100px' }}>{FilterResult?.reserveInfo?.phoneNumber}</td>
                            <th colSpan={9}>مدیر محترم به کروکی مهندسی پیوست هنگام توزیع اتاق ها توجه گردد.</th>
                          </tr>
                          <tr>
                            <td colSpan={11}>
                              <table cellSpacing={0} className='innertable'>
                                <tbody>
                                  {

                                    FilterResult?.planInfo?.floors.map((item) =>
                                      <ChunkedPlanRooms item={item} colorCode={FilterResult?.planInfo?.colorCode} />
                                    )
                                  }
                                </tbody>
                              </table>
                            </td>
                          </tr>
                          <tr>
                            <th rowSpan="3">توضیحات</th>
                            <td colSpan={11}><b style={{ color: red[500] }}>{FilterResult?.reserveInfo?.firstDescription}</b></td>
                          </tr>
                          <tr>
                            <td colSpan={11}>{FilterResult?.reserveInfo?.secondDescription}</td>
                          </tr>
                          <tr>
                            <td colSpan={11}>{FilterResult?.reserveInfo?.thirdDescription}</td>
                          </tr>
                          <tr>
                            <td colSpan={11}>
                              {/* <InitialPlanFooter PlanInfoStructure={FilterResult}/> */}
                              <InitialPlanFooter planInfo={FilterResult?.planInfo} countTreeBed={FilterResult?.planInfo?.countTreeBed} countTwoBed={FilterResult?.planInfo?.countTwoBed} countFourBed={FilterResult?.planInfo?.countFourBed} />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </>
              ) : isSubmitSuccessful && Object.keys(errors).length === 0 && <p>نتیجه ای یافت نشد</p>
          }
        </RtlProvider>
      </form>

      <Modal
        open={openPassengerInfoModal}
        onClose={handleClosePassengerInfoModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <RtlProvider>
          <Box sx={style}>

            <Box id="modal-modal-description" sx={{ mt: 2 }}>
              {passengerInfo && <PassengerInfo rows={passengerInfo} handleClosePassengerInfoModal={handleClosePassengerInfoModal} />}
            </Box>
          </Box>
        </RtlProvider>
      </Modal>

    </Container>
  )
}
